import React from 'react'
import styles from './styles.module.scss'

interface Props {
  touched: boolean | undefined
  error: string | undefined
}

const ErrorMessage = ({ touched, error }: Props) => {
  return <>{touched && error && <div className={styles['error-message']}>{error}</div>}</>
}

export default ErrorMessage
